import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { usePermissions } from '@/contexts/PermissionContext'
import { LoadingScreen } from '@/components/common/LoadingScreen'

interface PermissionGuardProps {
  permission: string | string[]
  requireAll?: boolean
  redirectTo?: string
  children: ReactNode
}

export const PermissionGuard = ({
  permission,
  requireAll = false,
  redirectTo = '/dashboard',
  children,
}: PermissionGuardProps) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions, loading } = usePermissions()

  if (loading) {
    return <LoadingScreen />
  }

  const permissions = Array.isArray(permission) ? permission : [permission]

  const hasAccess = requireAll
    ? hasAllPermissions(permissions)
    : permissions.length === 1
      ? hasPermission(permissions[0])
      : hasAnyPermission(permissions)

  if (!hasAccess) {
    return <Navigate to={redirectTo} replace />
  }

  return <>{children}</>
}
